import TrackInput from './TrackInput'
import Tracklist from './Tracklist'

const ListFormItemsInput = ({
  items,
  onAddItem,
  onClearItems,
  onDeleteItem,
  onRearrange,
}) => (
  <>
    {items.length > 0 && (
      <Tracklist
        items={items}
        onClearItems={onClearItems}
        onDeleteItem={onDeleteItem}
        onRearrange={onRearrange}
      />
    )}

    <div className="mb6 w-100">
      <TrackInput onAddItem={onAddItem} order={items.length} />
    </div>
  </>
)

export default ListFormItemsInput
